module.exports = __webpack_public_path__ + "media/images/pt/goals-segment-658a3a60385fee5bd1024271e2d9ada0.jpg";